(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["ifit-image-modal"]) return;
  try {
    
//<script> // For highlighting
  function showModalMesage(url) {
    var box = $('.ifit-modal-image-box');
    box.find('.ifit-modal-image-backdrop').scrollTop(0);
    box.find('.ifit-modal-image').attr('src', url);
    box.removeClass('ifit-hidden-image');
    $('body').addClass('noscroll');
  }

  window.iFitShowImageModalMessage = showModalMesage;
  $(function() {
    $('.ifit-modal-image-box').appendTo('body');
    $('.ifit-modal-image-popup,.ifit-modal-image-backdrop').click(function(e) {
      e.preventDefault();
      $('.ifit-modal-image-box').addClass('ifit-hidden-image');
      $('body').removeClass('noscroll');
    });
  });
  //</script>

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ifit-modal"]) return;
  try {
    
//<script> // For highlighting
  var callback;
  function showModalMesage(title, message, buttonText, cb) {
    if (cb) {
      if (callback) {
        callback('replaced');
      }
      callback = function(status) {
        callback = null;
        cb(status);
      };
    }
    var box = $('.ifit-modal-box');
    var showTitle = Boolean(title);
    box.find('.ifit-modal-title').text(title).toggle(showTitle);
    box.find('.ifit-modal-rule').toggle(showTitle);
    box.find('.ifit-modal-text-margin').toggle(!showTitle);
    box.find('.ifit-modal-text').text(message);
    box.removeClass('ifit-hidden-modal');
    if (buttonText === undefined) {
      buttonText = 'OK';
    }
    if (buttonText === null) {
      box.find('button').hide();
      box.find('.ifit-modal-close').show();
    } else {
      box.find('button').text(buttonText).show();
      box.find('.ifit-modal-close').hide();
    }
    $('body').addClass('noscroll');
  }

  window.iFitShowModalMessage = showModalMesage;
  $(function() {
    $('.ifit-modal-box').appendTo('body');
    $('.ifit-modal-popup .ifit-modal-close,.ifit-modal-popup .ifit-modal-button,.ifit-modal-backdrop').click(function(e) {
      e.preventDefault();
      $('.ifit-modal-box').addClass('ifit-hidden-modal');
      $('body').removeClass('noscroll');
      var className = e.target.className.split(/\s+/).filter(function(name) {
        return /^ifit-modal-/.test(name);
      })[0];
      var action = {
        'ifit-modal-close': 'closed',
        'ifit-modal-button': 'button clicked',
        'ifit-modal-backdrop': 'backdrop clicked'
      }[className] || 'unknown';
      if (callback) callback(action);
    });
  });
//</script>

  } catch(e) { console.error(e); }
})();

})();
